module.exports = __webpack_public_path__ + "media/images/emblems/Avenches-coat_of_arms-aacf2f94d833ce06fb282414afb23ace.png";